export const FORM_CONTROL_ERROR_CLASS = "form-control--has-error";
